import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";

export const WhatsAppCTA = () => (
    <section data-testid="whatsapp-cta-section" className="relative overflow-hidden bg-teal-accent py-20 text-white lg:py-24">
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/10"
        />
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-ink/10"
        />
        <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-8 px-5 text-center">
            <Reveal>
                <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-white/15 backdrop-blur-sm">
                    <MessageCircle className="h-7 w-7" />
                </span>
                <h2 className="mt-6 font-display text-4xl font-light leading-tight sm:text-5xl">
                    Have Questions About Your <em className="font-medium">Dental Care?</em>
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-base text-teal-50 md:text-lg">
                    Chat with Smile Dental Clinic directly on WhatsApp.
                </p>
            </Reveal>
            <Reveal delay={0.15}>
                <button
                    data-testid="whatsapp-cta-btn"
                    className="rounded-full bg-white px-9 py-4 text-sm font-extrabold uppercase tracking-[0.15em] text-teal-700 shadow-xl transition-[background-color,transform,color] duration-300 hover:-translate-y-0.5 hover:bg-ink hover:text-white"
                >
                    Chat on WhatsApp
                </button>
            </Reveal>
        </div>
    </section>
);
